import { Command, Option } from "clipanion";
import { DefaultAzureCredential } from "@azure/identity";
import { M8tCommand } from "../../lib/m8t-command.js";
import { colors, renderJson, resolveOutputMode } from "../../lib/output.js";
import { resolveFoundryProject } from "../../lib/foundry-project.js";
import { getAzAccount } from "../../lib/auth.js";
import { readAgentYaml } from "../../lib/agent-yaml.js";
import { disableA2a } from "../../lib/a2a-enable.js";

export class A2aDisableCommand extends M8tCommand {
  static paths = [["a2a", "disable"]];
  static usage = Command.Usage({
    description: "Disable agent-to-agent delegation for a worker (remove tool + connection + metadata). Idempotent.",
    examples: [["Disable the cmo persona", "$0 a2a disable cmo"]],
  });

  worker = Option.String();
  endpoint = Option.String("--endpoint");
  subscription = Option.String("--subscription");
  output = Option.String("--output");

  async executeCommand(): Promise<number> {
    const outputFlag = this.output === "json" || this.output === "auto" || this.output === "pretty" ? (this.output) : "pretty";
    const mode = resolveOutputMode(outputFlag, this.context.stdout as NodeJS.WriteStream);
    const progress = mode === "pretty" ? (m: string) => this.context.stderr.write(`  ${colors.dim(m)}\n`) : undefined;

    const credential = new DefaultAzureCredential();
    const account = await getAzAccount();
    const subscriptionId = (typeof this.subscription === "string" ? this.subscription : undefined) ?? account.subscriptionId;
    const project = await resolveFoundryProject({
      credential, subscriptionId,
      interactive: (this.context.stdout as NodeJS.WriteStream).isTTY === true,
      endpoint: typeof this.endpoint === "string" ? this.endpoint : undefined,
      agentEndpoint: readAgentYaml(this.worker)?.projectEndpoint,
    });

    const result = await disableA2a({
      credential,
      projectEndpoint: project.endpoint,
      projectArmId: `${project.accountScope}/projects/${project.projectName}`,
      agentName: this.worker,
      onProgress: progress,
    });

    if (mode === "json") { this.context.stdout.write(renderJson({ worker: this.worker, ...result }) + "\n"); return 0; }
    this.context.stdout.write(`${colors.success("✓")} ${colors.field(this.worker)} a2a-disabled (connection ${colors.field(result.connectionName)} removed, agent version ${result.foundryVersion ?? ""}).\n`);
    return 0;
  }
}
